module.exports = {
  // Turbolinks 5+ got rid of named events (?!)
  setup: function setup(ujs) {
    ujs.handleEvent('turbolinks:load', ujs.handleMount);
    ujs.handleEvent('turbolinks:before-render', ujs.handleUnmount);
  },
  teardown: function teardown(ujs) {
    ujs.removeEvent('turbolinks:load', ujs.handleMount);
    ujs.removeEvent('turbolinks:before-render', ujs.handleUnmount);
  }
};